var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badgeImage",class:_vm.size},[_c('BaseImage',{attrs:{"type":_vm.type,"src":_vm.src}}),(_vm.showBadge && _vm.badgeImg)?_c('img',{staticClass:"badge-image",attrs:{"src":_vm.badgeImg}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }